
import { defineComponent } from "vue";
import meetlookup from "../MeetLookup";
import { EventResults } from "@/types/EventResults";
import { Club, ClubAthlete } from "@/types/Club";
import { Result } from "@/types/EventResults";
import { Athlete } from "@/types/Athlete";
import AthletesTable from "@/components/AthletesTable.vue";

import axios from "axios";
import Plotly from "plotly.js-dist-min";
export default defineComponent({
  mixins: [meetlookup],
  components: {
    AthletesTable,
  },
  data: function () {
    return {
      result: (null as unknown) as Result,
      eventResults: (null as unknown) as EventResults,
      athletesFocus: [] as Array<Athlete>,
      agegroupname: "",
      plotReady: false,
      plotlyData: null as unknown,
      wideScreen: false,
      club: (null as unknown) as Club,
    };
  },
  watch: {
    "$route.params.eventid": function () {
      this.plotReady = false;
      let element = document.getElementById("progress");
      if (element) {
        element.innerHTML = "";
      }
      this.fetchResult();
    },
  },
  methods: {
    fetchMultiAthlete() {
      this.fetchAthlete(
        this.club.athletes.filter(
          (athlete) => athlete.id == this.$route.params.athleteid
        ),
        this.athletesFocus
      );
    },

    fetchAthlete(clubAthletes: Array<ClubAthlete>, athletes) {
      for (let idx = 0; idx < clubAthletes.length; idx++) {
        axios
          .get(
            "https://live.swimrankings.net/meets/" +
              this.$route.params.meetid +
              "/athletes/" +
              clubAthletes[idx].id +
              ".json",
            { params: { t: new Date().getTime() } }
          )
          .then((response) => response.data as Athlete)
          .then((athlete) => {
            for (let idx = 0; idx < athlete.results.length; idx++) {
              if (
                this.get_seconds_from_swimrankingstime(athlete.results[idx].swimtime) <
                this.get_seconds_from_swimrankingstime(athlete.results[idx].entrytime)
              ) {
                athlete.results[idx].isPb = true;
              } else {
                athlete.results[idx].isPb = false;
              }
              var performance =
                this.get_seconds_from_swimrankingstime(athlete.results[idx].entrytime) /
                this.get_seconds_from_swimrankingstime(athlete.results[idx].swimtime);
              athlete.results[idx].performance = performance * performance;
              athlete.results[idx].eventnr = this.get_event_number_from_event_id(
                athlete.results[idx].eventid
              );
            }
            athlete.results.sort(function (result_a, result_b) {
              if (result_a.eventnr && result_b.eventnr) {
                return (
                  result_a.eventnr - result_b.eventnr ||
                  parseInt(result_a.eventid) - parseInt(result_b.eventid)
                );
              }
              return 0;
            });

            for (let idx = 0; idx < athlete.entries.length; idx++) {
              athlete.entries[idx].eventnr = this.get_event_number_from_event_id(
                athlete.entries[idx].eventid
              );
            }
            athlete.entries.sort(function (entry_a, entry_b) {
              if (entry_a.eventnr && entry_b.eventnr) {
                return (
                  entry_a.eventnr - entry_b.eventnr ||
                  parseInt(entry_a.eventid) - parseInt(entry_b.eventid)
                );
              }
              return 0;
            });

            athletes.push(athlete);

            athletes.sort(function (athlete_a, athlete_b) {
              var sort_name = 1;
              if (athlete_b.fullname > athlete_a.fullname) {
                sort_name = -1;
              }
              return (
                parseInt(athlete_a.gender) - parseInt(athlete_b.gender) ||
                athlete_b.age - athlete_a.age ||
                sort_name
              );
            });
          });
      }
    },
    fetchClub() {
      axios
        .get(
          "https://live.swimrankings.net/meets/" +
            this.$route.params.meetid +
            "/clubs/" +
            this.get_club_id_from_athlete_id(String(this.$route.params.athleteid)) +
            ".json",
          { params: { t: new Date().getTime() } }
        )
        .then((response) => {
          this.club = response.data;
          this.fetchMultiAthlete();
        });
    },
    fetchResult() {
      let url =
        "https://live.swimrankings.net/meets/" +
        this.$route.params.meetid +
        "/results/" +
        this.$route.params.eventid +
        ".json";

      axios
        .get(url, { params: { t: new Date().getTime() } })
        .then((response) => response.data)
        .then((data) => {
          this.eventResults = data;

          for (let i = 0; i < this.eventResults.agegroups.length; i++) {
            for (let k = 0; k < this.eventResults.agegroups[i].results.length; k++) {
              if (
                this.eventResults.agegroups[i].results[k].athleteid ==
                this.$route.params.athleteid
              ) {
                this.result = this.eventResults.agegroups[i].results[k];
                this.agegroupname = this.get_agegroup_name_from_agegroup_id(
                  this.eventResults.agegroups[i].id
                );
                break;
              }
            }
          }

          if (
            this.get_swrid_from_athlete_id(String(this.$route.params.athleteid)) &&
            this.get_style_from_event_id(String(this.$route.params.eventid))
          ) {
            var post_data;
            if (this.result) {
              post_data = {
                athletes: ["ID:" + this.result.swrid],
                style: this.get_style_from_event_id(String(this.$route.params.eventid)),
                athletesSwimtimes: [
                  [
                    {
                      swimtime: this.result.swimtime,
                      swimdate: this.get_date_from_event_id(
                        String(this.$route.params.eventid)
                      ),
                      course: this.get_course_label_from_course_id(this.main.course),
                    },
                  ],
                ],
                courseType: "ACM",
                offsetWidth: 600,
                isMobile: true,
                extInfo: [],
                showLegend: false,
              };
            } else {
              post_data = {
                athletes: [
                  "ID:" +
                    this.get_swrid_from_athlete_id(String(this.$route.params.athleteid)),
                ],
                athletesSwimtimes: [],
                style: this.get_style_from_event_id(String(this.$route.params.eventid)),
                courseType: "ACM",
                offsetWidth: 600,
                isMobile: true,
                extInfo: [],
                showLegend: false,
              };
            }
            axios({
              method: "post",
              url: "https://swimstats.net/single",
              data: JSON.stringify(post_data),
              headers: {
                "Content-Type": "application/json; charset=utf-8",
              },
            }).then((results) => {
              this.plotReady = true;
              this.plotlyData = results.data.payload;
              if (screen.width > 600) {
                results.data.payload["layout"].width = null;
                results.data.payload["layout"].height = 500;
              } else {
                results.data.payload["layout"].width = null;
                results.data.payload["layout"].height = 300;
              }

              results.data.payload["layout"].title = "";

              results.data.payload["layout"].margin = { l: 0, r: 0, t: 0, b: 25 };
              results.data.payload["layout"].xaxis.title = null;

              Plotly.newPlot(
                document.getElementById("progress"),
                results.data.payload["traces"],
                results.data.payload["layout"],
                {
                  displayModeBar: false,
                  displaylogo: false,
                }
              );
            });
          }
        });
    },
  },
  created() {
    this.$gtag.event("live", {
      event_category: "live_pageload",
      event_label: "live_result",
    });

    if (screen.width > 600) {
      this.wideScreen = true;
    }
    this.athletesFocus = [];
    this.fetchClub();
    this.fetchResult();
  },
  beforeUnmount() {
    let element = document.getElementById("progress");
    if (element) {
      element.innerHTML = "";
    }
  },
});
